import presentationDefaultState from './presentation'
import slideActiveDefaultState from './slideActive'
import teamDefaultState from './team'
import folderDefaultState from './folder'

export default {
  ...presentationDefaultState,
  ...slideActiveDefaultState,
  ...teamDefaultState,
  ...folderDefaultState,
}
